import React, { Component } from "react";
import { Form, Button } from "react-bootstrap";
import errorConfig from "../../config/errorConfig.json";
import { getFromStorage } from "../../utils/storage";
import { withRouter } from "react-router-dom";
import key from "../../config/key.json";
import { toast } from "react-toastify";
import Api from "../../config/api.json";
import axios from "axios";

class ChangePassword extends Component {
  state = {
    oldPass: "",
    newPass: "",
    newPassAgain: "",
    isSubmitting: false
  };

  //Error Notification
  notifyError = error => {
    toast.error("" + error.toString());
  };
   //Success Notification
   notifySuccess = success => {
    toast.success("" + success.toString());
  };

  whenChangeHandler = e => {
    const { name, value } = e.target;
    this.setState({ [name]: value }, () => {
      toast.dismiss();
    });
    };

    changePassword = (password) => {
      const body = {
        task: 'changePassword',
        role: getFromStorage(key.loginInfoKey).task === "authAdmin" ? "admin" : "diagnostic",
        id: getFromStorage("owner_id"),
        password
      }
      const headers = { headers: { "Content-Type" : "application/json" } }
      axios.post(Api.postMethodURL, body, headers)
      .then(res => {
          if(!res.data.errorMessage){
              this.setState({newPass: "", newPassAgain: ""})
              this.notifySuccess("Password Changed Successfully");
          } else {
              this.notifyError("Password didn't changed");
          }
          this.setState({isSubmitting: false})
      }
      )
      .catch(err => {
          this.notifyError(err.toString());
          this.setState({isSubmitting: false})
      })
  }

  onClickChangepassHandler = e => {
    e.preventDefault();
    this.setState({isSubmitting: true}, () => {
      if (
        this.state.newPass.trim() !== "" &&
        this.state.newPassAgain.trim() !== ""
      ) {
        if (this.state.newPassAgain !== this.state.newPass) {
          this.notifyError("New Passwords are not equal");
          this.setState({isSubmitting: false})
        } else {
          axios
          .post("/create/md5", {password: this.state.newPass})
          .then(res => {
            this.changePassword(res.data.md5)
          }).catch(err => {
            this.notifyError("All Fields Required");
            this.setState({isSubmitting: false})
          })
        }
      } else {
        this.notifyError("All Fields Required");
        this.setState({isSubmitting: false})
      }
    })
  };

  //First function run when page load
  componentDidMount() {
    toast.dismiss();
    if (!getFromStorage(key.loginInfoKey)) {
      this.notifyError(errorConfig.notLoggedInError);
      this.props.history.push("/");
    } else if (getFromStorage(key.loginInfoKey).task === "authAdmin") {

    } else if (getFromStorage(key.loginInfoKey).task === "authDiagAdminPanel"){
   
    } else if (getFromStorage(key.loginInfoKey).task === "patient" || getFromStorage(key.loginInfoKey).task === "doctor") {
      this.props.history.push("/home");
    } else if (getFromStorage(key.loginInfoKey).task === "provider") {
      this.props.history.push("/provider_doctors")
    }
  }

  render() {
    if (getFromStorage(key.loginInfoKey)) {
      return (
        <div style={{ marginLeft: "80px", color: "teal", marginRight: "20px", marginTop: "110px" }} align="center">
          <form
            onSubmit={this.onClickChangepassHandler}
            style={{ textAlign: "center", overflowX: "auto" }}
          >
            {/* <Form.Group>
              <Form.Label style={{fontWeight: "bold"}}>Old Password</Form.Label>
              <Form.Control
                type="password"
                value={this.state.oldPass}
                name="oldPass"
                onChange={this.whenChangeHandler}
                style={{
                  width: "300px",
                  marginLeft: "auto",
                  marginRight: "auto"
                }}
                align="center"
              />
            </Form.Group> */}
            <Form.Group>
              <Form.Label style={{fontWeight: "bold"}}>New Password</Form.Label>
              <Form.Control
                type="password"
                value={this.state.newPass}
                name="newPass"
                onChange={this.whenChangeHandler}
                style={{
                  width: "300px",
                  marginLeft: "auto",
                  marginRight: "auto"
                }}
                align="center"
              />
            </Form.Group>
            <Form.Group>
              <Form.Label style={{fontWeight: "bold"}}>Retype New Password</Form.Label>
              <Form.Control
                type="password"
                value={this.state.newPassAgain}
                name="newPassAgain"
                onChange={this.whenChangeHandler}
                style={{
                  width: "300px",
                  marginLeft: "auto",
                  marginRight: "auto"
                }}
                align="center"
              />
            </Form.Group>
            <Button variant="success" disabled={this.state.isSubmitting} type="submit">
              {!this.state.isSubmitting ? "Change Password" : "Loading..."}
            </Button>
          </form>
        </div>
      );
    } else {
      return <div></div>;
    }
  }
}

export default withRouter(ChangePassword);
